import {FC, useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {useLazyQuery} from '@apollo/client'
import {GET_ORDER} from 'app/features/orders/graphql'
import {useDispatch, useSelector} from 'react-redux'
import {SimplePage} from '_core'
import {formatToShortDateString} from 'app/format/date'
import {Customer} from 'app/features/orders/components'
import {setOrder, clearFulfillmentState} from 'app/features/orders/redux/fulfillment/orderSlices'
import {Packages, ShippingItems} from './components'
import ShippingMethods from './components/ShippingMethods'
import {RootState} from 'setup'
import Summary from './components/Summary'
import {deliveryTypes} from 'app/constant'
import {OrderHeader} from '../../componentsv1'
import {addressTypes, mapToAddress} from '../../redux/order/helper'

type Props = {}

const ShippingService: FC<Props> = () => {
  const dispatch = useDispatch()
  const [getOrder, {data, loading, error}] = useLazyQuery(GET_ORDER, {
    fetchPolicy: 'cache-and-network',
  })

  const order = useSelector<RootState>(({orders}) => orders.fulfillment.order.order) as any
  const {orderId} = useParams<any>()

  useEffect(() => {
    if (orderId) {
      getOrder({variables: {id: orderId}})
    }
  }, [orderId, getOrder])

  useEffect(() => {
    if (data) {
      dispatch(
        setOrder({
          ...data.order,
          shippingAddress: mapToAddress(
            data.order.orderAddressProfiles?.nodes,
            data.order.shippingAddress,
            addressTypes.shipping
          ),
          billingAddress: mapToAddress(
            data.order.orderAddressProfiles?.nodes,
            data.order.billingAddress,
            addressTypes.billing
          ),
        })
      )
    }
    return () => {
      dispatch(clearFulfillmentState())
    }
  }, [data, dispatch])

  return (
    <SimplePage loading={loading} error={error}>
      {order && (
        <>
          <OrderHeader
            title={<>Fulfillment - {`#${order.orderNumber}`} (Carrier postage directly)</>}
            routePath={`/orders/${orderId}/fulfillments/view`}
            subTitle={
              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column'>
                  <div className='text-muted fs-7 fw-bold'>
                    {formatToShortDateString(order.createdAt)}
                  </div>
                </div>
              </div>
            }
          />
          <div className='row gy-5 g-xl-8'>
            <div className='col-xl-8'>
              <ShippingItems items={order.orderItems} />

              <Packages />

              {data && <ShippingMethods order={order} />}
            </div>
            <div className='col-xl-4'>
              {data && (
                <Customer
                  id={data.order?.id}
                  customer={data.order.customer}
                  shippingAddress={order.shippingAddress}
                  billingAddress={order.billingAddress}
                  paymentMethod={data.order.paymentMethod}
                  isShowCompany={order?.orderDeliveryMethod === deliveryTypes.ship}
                />
              )}
              <Summary />
            </div>
          </div>
        </>
      )}
    </SimplePage>
  )
}

export default ShippingService
